// Master has no clinic of their own, so several nav links (Warehouse, etc.)
// that assume "the current clinic" need a stand-in for master. This tracks
// the id of whichever clinic master most recently opened
// (ClinicView.jsx sets it), so those links can resolve contextually instead
// of pointing at a dead, id-less URL. sessionStorage (not localStorage) so
// it doesn't leak stale state across days/logins.
export const MASTER_LAST_BROWSED_CLINIC_ID_KEY = "masterLastBrowsedClinicId";

export function getMasterLastBrowsedClinicId() {
  return sessionStorage.getItem(MASTER_LAST_BROWSED_CLINIC_ID_KEY);
}
